module.exports = {
	emailValidator: (rule, value, callback) => {
		// eslint-disable-next-line
		let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		if (re.test(String(value).toLowerCase())) {
			callback();
		} else {
			callback(new Error("Invalid email address provided"));
		}
	},
	slugValidator: (rule, value, callback) => {
		var re = /^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*$/;

		if (re.test(value)) {
			callback();
		} else {
			callback(new Error("Please only use letters, numbers and dashes"));
		}
	},
	urlValidator: (rule, value, callback) => {
		console.log("running", 1231);

		var re = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i;
		console.log("result", re.test(value), value);

		if (re.test(value)) {
			callback();
		} else {
			callback(new Error("Please provide a valid url (https://example.com)"));
		}
	},
	passwordValidator: (rule, value, callback) => {
		if (value == null) {
			callback();
		}

		var re = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$/;
		if (re.test(value)) {
			if (value.length > 9) {
				callback();
			} else {
				callback(new Error("The password is not long enough."));
			}
		} else {
			callback(new Error("The password is not secure enough."));
		}
	}
};
